import * as storageApi from '@/api/storage'
import * as postsApi from '@/api/posts'

const state = {
  files: [],
  usage: { used_bytes: 0, limit_bytes: 0, file_count: 0 },
  total: 0,
  loading: false,
  uploading: false,
  source: '',
}

const getters = {
  files: (s) => s.files,
  usage: (s) => s.usage,
  total: (s) => s.total,
  loading: (s) => s.loading,
  uploading: (s) => s.uploading,
  source: (s) => s.source,
}

const actions = {
  async fetchFiles({ commit }, { source = '', limit = 100, offset = 0 } = {}) {
    commit('SET_LOADING', true)
    commit('SET_SOURCE', source)
    try {
      const { data } = await storageApi.listStorage({ source, limit, offset })
      const payload = data.data || {}
      commit('SET_FILES', payload.files || [])
      commit('SET_USAGE', payload.usage || state.usage)
      commit('SET_TOTAL', payload.total || 0)
      return payload
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchUsage({ commit }) {
    const { data } = await storageApi.getStorageUsage()
    commit('SET_USAGE', (data.data && data.data.usage) || data.usage || {})
  },

  async uploadFile({ dispatch, state }, file) {
    const { data } = await postsApi.uploadMedia(file)
    await dispatch('fetchFiles', { source: state.source })
    return data.data || data
  },

  async deleteFile({ dispatch, state: s }, id) {
    await storageApi.deleteStorageFile(id)
    await dispatch('fetchFiles', { source: s.source })
  },

  async deleteAllFiles({ dispatch, state: s }) {
    const { data } = await storageApi.deleteAllStorage({ source: s.source || undefined })
    await dispatch('fetchFiles', { source: s.source })
    return data.data || data
  },
}

const mutations = {
  SET_FILES(state, files) { state.files = files },
  SET_USAGE(state, usage) { state.usage = usage },
  SET_TOTAL(state, total) { state.total = total },
  SET_LOADING(state, loading) { state.loading = loading },
  SET_UPLOADING(state, uploading) { state.uploading = uploading },
  SET_SOURCE(state, source) { state.source = source },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
